import { Wrapper, ContentWrapper, ArrowButton, UnderlineGraphic, LocationWrapper } from './Editorial.styles'
import Icon from '../Icons'
import Link from 'next/link'
import { Heading } from '@big-red-group/storefront-common-ui'
type HeaderProps = {
  image?: string
  title: string
  description: string
  link: string
}

const Editorial: React.FC<HeaderProps> = ({ image, title, description, link }) => {
  return (
    <div data-testid="editorial">
      {image && (
        <Link href={link}>
          <Wrapper image={image}>
            {/* Disabled, potential to add in future release */}
            {/* <LocationWrapper data-testid="location">
            <Icon name="location" />
            {location}
          </LocationWrapper> */}
            <ContentWrapper>
              <Heading size="XS" as="h1" dataTestId="title">
                {title}
                <UnderlineGraphic>
                  <Icon name="underline" width={76} height={7} fill="#FFFFFF" />
                </UnderlineGraphic>
              </Heading>
              <Heading dataTestId="description" size="XL">
                {description}
              </Heading>
              <ArrowButton>
                <Icon name="rightarrow" width={24} height={24} />
              </ArrowButton>
            </ContentWrapper>
          </Wrapper>
        </Link>
      )}
    </div>
  )
}

export default Editorial
